import { data } from "./MainPage.data";
import { dataTerminal } from "./MainPageTerminal.data";

import { isTerminal, iframeProxyEpassport, CLAIMS } from "../../../constants";
import MultiRoute from "../../common/MultiRoute/MultiRoute";
import Header from "../../layout/Header/Header";
import Footer from "../../layout/Footer/Footer";
import ModalBanOverlay from "../../common/Modal/ModalBanOverlay/ModalBanOverlay";
import WorkerSignType from "../../common/Modal/ModalConditions/UserSignType/WorkerSignType/WorkerSignType";

import UButton from "../../common/Button/UButton/UButton";
import { Modal } from "../../common/Modal/Modal";

import {
    getMaintenanceNotificationThunkAction,
} from "../../../redux/actions/User/Notification/thunk/getMaintenanceNotification.thunk.action";
import AuthService from "../../../redux/services/AuthService";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

isTerminal ? import("./MainPageTerminal.scss") : import("./MainPage.scss");

const style = isTerminal ? null : { marginTop: "30px", minHeight: "40vh" };
const routers = isTerminal ? dataTerminal : data;

const MainPage = () => {
    const dispatch = useDispatch();

    const claims = useSelector(state => state.user?.claims);

    const [errorModal, setErrorModal] = useState(false);
    const [errDescription, setErrDescription] = useState("");
    const [actualDocumentsModal, setActualDocumentsModal] = useState(false);
    const [isOpen, setOpened] = useState(false);
    const [fio] = useState(JSON.parse(localStorage.getItem("fio")));


    function closeModal() {
        setErrorModal(false);
    }

    useEffect(() => {
        console.log("CLAIMS");
        if (claims && claims.length > 0 &&
            claims.find((element)=> element === CLAIMS.HAS_DOCUMENTS)) {
            console.log("CLAIMS.HAS_DOCUMENTS");
            setActualDocumentsModal(true);
            setErrorModal(true);
            setErrDescription(
                "Функциональность приложения ограничена." +
                " Чтобы продолжить работу с приложением," +
                " примите решение по всем документам," +
                " требующим ознакомления или подписания",
            );
        }

    }, [claims, claims?.length]);
    useEffect(() => {
        dispatch(getMaintenanceNotificationThunkAction());
    }, []);
    useEffect(() => {
        if (!localStorage.getItem("appointment") && fio) {
            AuthService.getHeaderInformation({ dispatch }).then(r => console.log(r));
        }
    }, []);
    return (
        <>
            <Header
                errorModal={errorModal}
                setErrorModal={setErrorModal}
                errDescription={errDescription}
                setErrDescription={setErrDescription}
            />
            <section className={"mainPage"} style={style}>
                <div>
                    <MultiRoute
                        breadCrumbs={false}
                        data={routers}
                        styleParent={"main-page"}
                        securedMessage={localStorage.getItem("reason")}
                    />
                </div>
                {/*onClick={props.function}*/}
                {/*disabled={props.disabled? props.disabled : null}*/}
                {/*className={props.parentStyle}>*/}
                {/*{props.buttonText}*/}
                {!isTerminal && (
                    <UButton
                        className={"mainPage__button"}
                        onClick={() =>
                            window.open(isTerminal ? iframeProxyEpassport : "https://prn.alrosa.ru:5001/epassport")
                        }
                    >Сообщить о технической проблеме</UButton>
                )}
            </section>

            <ModalBanOverlay shown={errorModal} close={setErrorModal}>
                <WorkerSignType
                    close={closeModal}
                    path={"/documents"}
                    description={errDescription}
                    setErrorModal={setErrorModal}
                    closeButton={true}
                    block={actualDocumentsModal ? true : null}
                />
            </ModalBanOverlay>
            <Footer />
        </>
    );
};

export default MainPage;
